
import {
  Email,
  Phone,
  LocationOn,
  YouTube,
  ArrowForward,
} from "@mui/icons-material";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import TelegramIcon from "@mui/icons-material/Telegram";
import TamaraEn from "../../assets/images/tamaraEn.png";
import TamaraAr from "../../assets/images/tamaraAr.png";

import "./Footer.scss";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";

const Footer = () => {
  const { t } = useLanguage();
  const { socialLinks } = useAuth();

  const scrollToSection = (sectionId) => {
    // Check if we're on the home page
    const isHomePage =
      window.location.pathname === "/" || window.location.pathname === "/home";

    if (isHomePage) {
      // If already on home page, scroll to the section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // If not on home page, navigate to home page with hash
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-container">
          <div className="footer-main-section">
            <div className="footer-logo-section">
              <h2 className="footer-brand">{t("companyName")}</h2>
              <p className="footer-slogan">{t("footerSlogan")}</p>
              <div className="footer-social">
                {socialLinks?.faceBookLink && (
                  <a
                    href={socialLinks.faceBookLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <FacebookIcon />
                  </a>
                )}
                {socialLinks?.xLink && (
                  <a
                    href={socialLinks.xLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter"
                  >
                    <TwitterIcon />
                  </a>
                )}
                {socialLinks?.instagramLink && (
                  <a
                    href={socialLinks.instagramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <InstagramIcon />
                  </a>
                )}
                {socialLinks?.whatsAppLink && (
                  <a
                    href={socialLinks.whatsAppLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="WhatsApp"
                  >
                    <WhatsAppIcon />
                  </a>
                )}
                {socialLinks?.telegramLink && (
                  <a
                    href={socialLinks.telegramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Telegram"
                  >
                    <TelegramIcon />
                  </a>
                )}
                {socialLinks?.youTubeLink && (
                  <a
                    href={socialLinks.youTubeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                  >
                    <YouTube />
                  </a>
                )}
              </div>
            </div>

            <div className="footer-sections-wrapper">
              <div className="footer-section">
                <h3 className="footer-title">{t("quickLinks")}</h3>
                <ul className="footer-links">
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("about");
                      }}
                    >
                      {t("aboutUs")} <ArrowForward className="arrow-icon" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("services");
                      }}
                    >
                      {t("ourServices")} <ArrowForward className="arrow-icon" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("subscription");
                      }}
                    >
                      {t("packages")} <ArrowForward className="arrow-icon" />
                    </a>
                  </li>
                  <li>
                    <a href="/contact">
                      {t("contactUs")} <ArrowForward className="arrow-icon" />
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-section">
                <h3 className="footer-title">{t("ourServices")}</h3>
                <ul className="footer-links">
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("services");
                      }}
                    >
                      {t("plumbingServices")}{" "}
                      <ArrowForward className="arrow-icon" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("services");
                      }}
                    >
                      {t("electricalServices")}{" "}
                      <ArrowForward className="arrow-icon" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("services");
                      }}
                    >
                      {t("comingSoonCleaning")}{" "}
                      <ArrowForward className="arrow-icon" />
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("services");
                      }}
                    >
                      {t("comingSoonAC")}{" "}
                      <ArrowForward className="arrow-icon" />
                    </a>
                  </li>
                </ul>
              </div>

              <div className="footer-section">
                <h3 className="footer-title">{t("contactUs")}</h3>
                <ul className="footer-contact">
                  <li>
                    <LocationOn className="footer-icon" />
                    <span>{t("companyAddress")}</span>
                  </li>
                  <li>
                    <Phone className="footer-icon" />
                    <span>0536785505</span>
                  </li>
                  <li>
                    <WhatsAppIcon className="footer-icon" />
                    <span>0536785505</span>
                  </li>
                  <li>
                    <Email className="footer-icon" />
                    <span>houfalmanazel@gmail.com</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="payment-methods">
            <h3 className="payment-title">{t("paymentMethods")}</h3>
            <div className="payment-icons">
              <div className="payment-icon">
                <div className="payment-icon-img">
                  <img
                    src="https://framerusercontent.com/images/aDZScdKgJb4BvDiUJfdZHr7Odao.png?scale-down-to=512"
                    alt={t("muyassar")}
                  />
                </div>
                <span>{t("muyassar")}</span>
              </div>
              <div className="payment-icon">
                <div className="payment-icon-img">
                  <img
                    src="https://framerusercontent.com/images/kxwavjqngOZVx7MenKDgXml3xFY.png?scale-down-to=512"
                    alt={t("mada")}
                  />
                </div>
                <span>{t("mada")}</span>
              </div>
              <div className="payment-icon">
                <div className="payment-icon-img">
                  <img
                    src="https://framerusercontent.com/images/iF6pDpliThuRXQ0cL1YKrx5xjnk.png?scale-down-to=512"
                    alt={t("visa")}
                  />
                </div>
                <span>{t("visa")}</span>
              </div>
              <div className="payment-icon">
                <div className="payment-icon-img">
                  <img
                    src="https://framerusercontent.com/images/lrnNBBmyhNdZrHUzr30XXjtCaZ0.png?scale-down-to=512"
                    alt={t("mastercard")}
                  />
                </div>
                <span>{t("mastercard")}</span>
              </div>
              <div className="payment-icon">
                <div className="payment-icon-img">
                  <img
                    src={t("language") === "ar" ? TamaraAr : TamaraEn}
                    alt={t("tamara")}
                  />
                </div>
                <span>{t("tamara")}</span>
              </div>
              <div className="payment-icon">
                <div className="payment-icon-img">
                  <img
                    src="https://framerusercontent.com/images/hTqGFwU0NDFFuXk3EFMBCGrggYw.png?scale-down-to=512"
                    alt="STC Pay"
                  />
                </div>
                <span>STC Pay</span>
              </div>
              <div className="payment-icon">
                <div className="payment-icon-img">
                  <img
                    src="https://framerusercontent.com/images/G2amYybXOGkMbmX9jPdwVkvYu6I.png?scale-down-to=512"
                    alt="Apple Pay"
                  />
                </div>
                <span>Apple Pay</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-container">
          <p className="copyright">
            {t("copyright")} © {new Date().getFullYear()} {t("companyName")}
          </p>
          <div className="footer-bottom-links">
            <a href="/terms">{t("termsAndConditions")}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
